import { render } from "./BuyCreditsModal.vue?vue&type=template&id=b1ddae9c"
import script from "./BuyCreditsModal.vue?vue&type=script&lang=js"
export * from "./BuyCreditsModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__